import React, { useRef, useState } from "react";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import { ButtonStyleAzul, ButtonStyleWhite, DivBackgroundDasboard, DivStyleSend, MaxDiv, PaperStyle, TypographyStyleSecundary } from "../../styles/Styles";
import { ListItemButton } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import HeaderCustom from "../../components/header/HeaderCustom";
import html2canvas from "html2canvas";
import { QrCodeScanner, Send } from "@mui/icons-material";
import { exportComponentAsPNG } from "react-component-export-image";
import { LogoSicoopFondo } from "../../components/logos/LogoFondo";
import { ButtonFlotante } from "../../components/botonQr/ButtonFlotante";

const DetailsPage = () => {
    const { state } = useLocation();
    const CompartirRef = useRef();

    let history = useNavigate();

    const handleMontoPagado = () => {
        let montoPagado = 0;
        const tieneImporte = state && state.importe !== undefined && state.importe !== null;
        const tieneMonto = state && state.monto !== undefined && state.monto !== null;

        if (tieneImporte) {
            montoPagado = state.importe.toString().replace('00', '');
            return `Gs. ${parseInt(montoPagado || '0').toLocaleString('es-PY', { minimumFractionDigits: 0 })}`;
        }

        if (tieneMonto) {
            montoPagado = state.monto.toString().replace('00', '');
            return `Gs. ${parseInt(montoPagado || '0').toLocaleString('es-PY', { minimumFractionDigits: 0 })}`;
        }

        return 'Gs. 0';
    };

    const handleCaptureMobile = () => {
        html2canvas(CompartirRef.current)
            .then((canvas) => {
                const imgData = canvas.toDataURL('image/png');
                // console.log("imgData", imgData);
                window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'share', data: imgData, fileName: 'confirmacion_pago' }));
            })
            .catch((err) => {
                console.log("err", err);
            })
    };

    const downloadPng = async () => {
        await exportComponentAsPNG(CompartirRef, { fileName: 'confirmacion_pago' });
    };

    const handleShare = async () => {

        //enviar el mensaje a la webView de react native, para que se pueda compartir
        if (window.ReactNativeWebView) {//se valida si es una app de react native
            handleCaptureMobile();
        } else {
            console.log("es el navegador web");
            downloadPng();
        }

    }

    //volver atras
    const handleGoBack = () => {
        history(-1);
    };

    const handleEstado = (item) => {
        let estado = '';
        let validPagos = item && item.estadoPago;


        if (validPagos) {
            estado = item.estadoPago === 'Payment' ? 'Pagado' : item.estadoPago;
        } else {
            // estado = item.estado;
            if (item?.estado === 'PE') {
                estado = 'Pendiente';
            } else if (item?.estado === 'RE') {
                estado = 'Rechazado';
            } else if (item?.estado === 'AP') {
                estado = 'Aprobado';
            }
        }

        return estado.toUpperCase();
    };

    const handleFechaPagos = (item) => {
        let fechaPago = '';
        let validPagos = item && item.fechaPago;


        if (validPagos) {
            fechaPago = item.fechaPago;
        } else {
            fechaPago = item.fechaCreacion;
        }


        return fechaPago;
    };

    return (
        <HeaderCustom title="Historial">
            <MaxDiv>
                <PaperStyle style={{ padding: 0 }}>
                    {state && (
                        <div>
                            <DivStyleSend ref={CompartirRef}>
                                <div>
                                    <LogoSicoopFondo tamano={200} />
                                </div>

                                <TypographyStyleSecundary component="h5" variant="h5" align='center'>
                                    Detalles de la operación
                                </TypographyStyleSecundary>



                                <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                                    <ListItemText
                                        primary={
                                            <div style={{}}>
                                                <Typography
                                                    sx={{ display: 'inline', fontSize: '1rem', width: '50%' }}
                                                    component="span"
                                                    variant="subtitle1"
                                                >
                                                    Nro. de operación
                                                </Typography>
                                            </div>
                                        }
                                        secondary={
                                            <div style={{}}>
                                                <Typography
                                                    sx={{ display: 'inline' }}
                                                    component="span"
                                                    variant="subtitle1"
                                                >
                                                    {state.idTxDestinatario || state.idOperacion}
                                                </Typography>
                                            </div>
                                        }
                                    />

                                    <ListItemText
                                        primary={
                                            <div style={{}}>
                                                <Typography
                                                    sx={{ display: 'inline', fontSize: '1rem', width: '50%' }}
                                                    component="span"
                                                    variant="subtitle1"
                                                >
                                                    Estado
                                                </Typography>
                                            </div>
                                        }
                                        secondary={
                                            <div style={{}}>
                                                <Typography
                                                    sx={{ display: 'inline' }}
                                                    component="span"
                                                    variant="subtitle1"
                                                >
                                                    {/* {state.estadoPago ? state.estadoPago : ''} */}
                                                    {handleEstado(state)}
                                                </Typography>
                                            </div>
                                        }
                                    />

                                    <ListItemText
                                        primary={
                                            <div style={{}}>
                                                <Typography
                                                    sx={{ display: 'inline', fontSize: '1rem', width: '50%' }}
                                                    component="span"
                                                    variant="subtitle1"
                                                >
                                                    Fecha y hora
                                                </Typography>
                                            </div>
                                        }
                                        secondary={
                                            <div style={{}}>
                                                <Typography
                                                    sx={{ display: 'inline' }}
                                                    component="span"
                                                    variant="subtitle1"
                                                >
                                                    {/* {state.fechaPago ? `${state.fechaPago} Hs.` : 'dd/mm/aaaa 00:00 Hs.'} */}
                                                    {handleFechaPagos(state)}
                                                </Typography>
                                            </div>
                                        }
                                    />

                                    <ListItemText
                                        primary={
                                            <div style={{}}>
                                                <Typography
                                                    sx={{ display: 'inline', fontSize: '1rem', width: '50%' }}
                                                    component="span"
                                                    variant="subtitle1"
                                                >
                                                    Monto pagado
                                                </Typography>
                                            </div>
                                        }
                                        secondary={
                                            <div style={{}}>
                                                <Typography
                                                    sx={{ display: 'inline' }}
                                                    component="span"
                                                    variant="subtitle1"
                                                >
                                                    {handleMontoPagado()}
                                                </Typography>
                                            </div>
                                        }
                                    />
                                </List>
                            </DivStyleSend>




                            <DivStyleSend>
                                <div style={{}}>
                                    <ButtonStyleAzul
                                        variant="contained"
                                        style={{
                                            width: '100%',
                                            height: '50px',
                                            borderRadius: '10px'
                                        }}
                                        startIcon={<Send />}
                                        onClick={handleShare}
                                    >
                                        Compartir
                                    </ButtonStyleAzul>
                                </div>

                                <div style={{}}>
                                    <ButtonStyleWhite
                                        variant="contained"
                                        style={{
                                            width: '100%',
                                            height: '50px',
                                            borderRadius: '10px',
                                            color: '#333',
                                            fontSize: '12px'
                                        }}
                                        onClick={handleGoBack}
                                    >
                                        Cancelar
                                    </ButtonStyleWhite>
                                </div>
                            </DivStyleSend>



                        </div>
                    )}

                </PaperStyle>

                {/*agregar boton flotante*/}
                <ButtonFlotante />
            </MaxDiv>
        </HeaderCustom>
    )
}

export default DetailsPage;